/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoldersIcon16Solid = forwardRef('FoldersIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 1A1.5 1.5 0 0 0 0 2.5v8A2.5 2.5 0 0 0 2.5 13h8a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 10.5 3H6.537L5.505 1.607A1.5 1.5 0 0 0 4.3 1H1.5ZM2 6.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M15.5 5.75a.75.75 0 0 0-1.5 0v4.997a3.25 3.25 0 0 1-3.25 3.25h-7a.75.75 0 0 0 0 1.5h7a4.75 4.75 0 0 0 4.75-4.75V5.75Z" })));
});
